import { NoField } from "./components/NoField";
import { PaymentTypeField } from "./components/PaymentTypeField";
import { CurrencyField } from "./components/CurrencyField";
import { IssueDateField } from "./components/IssueDateField";
import { StatusField } from "./components/StatusField";
import { DueDateField } from "./components/DueDateField";

export const InvoiceForm = () => (
  <div className="grid grid-cols-3 gap-4">
    <NoField />
    <PaymentTypeField />
    <CurrencyField />
    <IssueDateField />
    <DueDateField />
    <StatusField />
  </div>
);
